<template>
    <div class="spark-content-view-holder" :class="{ 'modal-mode': props.displayMode === 'modal' }">
        <div v-if="isLoading" class="brand-loader-wrapper">
            <brand-loader />
        </div>
        <spark-content-viewer
            :spark-content-details="sparkContentDetails"
            :no-breadcrumb="props.noBreadcrumb"
            :display-mode="props.displayMode"
            :allow-comments-expand="props.allowCommentsExpand"
            v-else-if="sparkContentDetails"
            @updated="initialise"
            @navigated="emit('navigated')"
        />
        <no-pdf-view v-else-if="!isLoading" />
    </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue';
import { deltaGptApi } from '@/api/deltaGpt/deltaGptApi.ts';
import { ISparkContentDetails } from '@/interfaces/deltaGpt/IDocument.ts';
import NoPdfView from '@/views/404View.vue';
import BrandLoader from '@/components/layout/BrandLoader.vue';
import SparkContentViewer from './SparkContentViewer.vue';

const props = withDefaults(defineProps<{
    documentShortCode: string;
    noBreadcrumb?: boolean;
    displayMode?: 'page' | 'modal';
    allowCommentsExpand?: boolean;
}>(), {
    noBreadcrumb: false,
    displayMode: 'page',
    allowCommentsExpand: true,
});

const emit = defineEmits<{
    navigated: [void];
}>();

const sparkContentDetails = ref<ISparkContentDetails | undefined>();
const isLoading = ref<boolean>(false);

async function initialise (): Promise<void> {
    isLoading.value = true;

    try {
        sparkContentDetails.value = await deltaGptApi.getSparkContentDetails(props.documentShortCode);
    } finally {
        isLoading.value = false;
    }
}

initialise();
</script>

<style lang="scss" scoped>
.spark-content-view-holder {
    min-height: 0;

    &.modal-mode {
        display: flex;
        flex-direction: column;
        height: 100%;

        :deep(.document-viewer) {
            flex: 1 1 auto;
        }
    }
}

.brand-loader-wrapper {
    position: relative;
    height: 100%;
    min-height: 0;
}
</style>
